export type EventShareChannel = "whatsapp" | "facebook" | "shared_link";

const SHARE_MEDIUM: Record<EventShareChannel, string> = {
  whatsapp: "messaging",
  facebook: "social",
  shared_link: "sharing",
};

// A share is a new acquisition touch, not a copy of the sender's campaign or IDs.
export function eventShareUrl(
  href: string,
  eventId: number,
  channel: EventShareChannel,
): string | undefined {
  if (!Number.isSafeInteger(eventId) || eventId <= 0) return undefined;
  try {
    const current = new URL(href);
    if (
      !["https:", "http:"].includes(current.protocol) ||
      current.username ||
      current.password
    )
      return undefined;
    const link = new URL(`/event/${eventId}`, current.origin);
    link.searchParams.set("utm_source", channel);
    link.searchParams.set("utm_medium", SHARE_MEDIUM[channel]);
    link.searchParams.set("utm_campaign", `event_${eventId}`);
    link.searchParams.set("utm_content", "event_share");
    return link.href;
  } catch {
    return undefined;
  }
}
